import { useEffect, useState } from 'react';

export const MAPBOX_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_TOKEN || '';
export const MAPBOX_STYLE = 'mapbox://styles/mapbox/streets-v12';

// Mantener sincronizado con la versión de "mapbox-gl" en package.json.
const MAPBOX_GL_VERSION = '3.22.0';
const MAPBOX_CSS_URL = `https://api.mapbox.com/mapbox-gl-js/v${MAPBOX_GL_VERSION}/mapbox-gl.css`;

let cssPromise: Promise<void> | null = null;

// Inyectamos el CSS de mapbox-gl on-demand cuando monta el primer componente
// que usa el mapa, en vez de importarlo globalmente. Así rutas sin mapa no
// pagan los ~40 KB del CSS. Devolvemos una Promise compartida para que varios
// componentes simultáneos esperen el mismo onload.
export function ensureMapboxCss(): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve();
  if (cssPromise) return cssPromise;

  const existing = document.querySelector<HTMLLinkElement>('link[data-mapbox-css]');
  if (existing) {
    cssPromise = Promise.resolve();
    return cssPromise;
  }

  cssPromise = new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = MAPBOX_CSS_URL;
    link.dataset.mapboxCss = '';
    link.onload = () => resolve();
    link.onerror = () => reject(new Error('Failed to load mapbox-gl CSS'));
    document.head.appendChild(link);
  });

  return cssPromise;
}

export function useMapboxCss(): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    ensureMapboxCss()
      .then(() => { if (!cancelled) setReady(true); })
      .catch(() => { /* fallback: ready queda en false */ });
    return () => { cancelled = true; };
  }, []);

  return ready;
}
